module.exports = __webpack_public_path__ + "img/ocp.393ef81a.png";